<template>
  <div>

    <vs-card class="mb-6" v-if="branch.uuId">
      <div class="qr-content p-6 flex flex-col items-center">
        <h2 class="mb-4 text-xl">{{branch.name}} Şubesi için QR Kod</h2>

        <div class="qr-code-container mb-6 border p-4 bg-white">
          <qrcode :value="menuUrl" :size="qrCodeSize" level="H"></qrcode>
        </div>



        <div class="menu-url mb-6">
          <p class="mb-2"><b>Menü URL:</b></p>
          <div class="url-copy-container flex">
            <vs-input class="w-full mr-2" v-model="menuUrl" readonly></vs-input>
            <vs-button @click="copyUrl" icon-pack="feather" icon="icon-copy" color="primary">Kopyala</vs-button>
          </div>
          <div v-if="copied" class="text-success text-sm mt-1">
            URL kopyalandı!
          </div>
        </div>

        <div class="action-buttons flex">
          <vs-button class="mr-4" type="gradient" color="primary" @click="printQRCode">
            <i class="feather icon-printer mr-2"></i> Yazdır
          </vs-button>
          <vs-button type="gradient" color="success" @click="downloadPDF">
            <i class="feather icon-download mr-2"></i> PDF İndir
          </vs-button>
        </div>

      </div>
      <!-- QR Menu Settings -->
      <vs-card class="mb-6">
          <div slot="header">
            <h4 class="card-title">QR Menü Ayarları</h4>
          </div>
          <div class="p-4">
            <div class="mb-4">
              <label class="vs-label">Görsel Gösterimi:</label>
              <vs-switch v-model="settings.imageEnabled" color="success">
                <span slot="on">Açık</span>
                <span slot="off">Kapalı</span>
              </vs-switch>
              <small class="text-muted d-block mt-1">Menüde ürün görselleri gösterilsin mi?</small>
            </div>

                        <div class="mb-4">
              <label class="vs-label">Logo:</label>

              <!-- Logo Preview -->
              <div v-if="settings.logo" class="mb-3">
                <div class="logo-preview-container p-3 border rounded">
                  <img
                    :src="needUpload ? settings.logo : ($baseUrl + '/' + settings.logo)"
                    alt="Logo Preview"
                    class="logo-preview"
                    style="max-width: 150px; max-height: 80px; object-fit: contain;"
                  />
                </div>
                <vs-button
                  size="small"
                  color="primary"
                  @click="$refs.logoUploadInput.click()"
                  class="mt-2"
                >
                  <i class="feather icon-edit mr-1"></i> Logo Değiştir
                </vs-button>
              </div>

              <!-- Logo Upload -->
              <div v-else>
                <vs-button
                  @click="$refs.logoUploadInput.click()"
                  icon-pack="feather"
                  icon="icon-upload"
                  color="primary"
                >
                  Logo Yükle
                </vs-button>
              </div>

              <input
                type="file"
                class="hidden"
                ref="logoUploadInput"
                @change="updateLogoImg"
                accept="image/*"
              />

              <small class="text-muted d-block mt-1">Menüde görünecek logo (JPG, PNG, GIF)</small>
            </div>

            <vs-button
              @click="saveSettings"
              type="gradient"
              color="primary"
              :disabled="savingSettings"
            >
              <i class="feather icon-save mr-2"></i>
              {{ savingSettings ? 'Kaydediliyor...' : 'Ayarları Kaydet' }}
            </vs-button>
          </div>
        </vs-card>
    </vs-card>

    <vs-alert v-else color="danger" active>
      Şube bilgisi bulunamadı veya UUID bilgisi mevcut değil!
    </vs-alert>
  </div>
</template>

<script>
import { currentBranch, setQrMenuSetting, uploadImage } from "@/api/Branch";
import QRCode from 'qrcode-vue';
import jsPDF from 'jspdf';

export default {
  name: 'QRMenu',
  components: {
    'qrcode': QRCode
  },
  data() {
    return {
      branch: {},
      baseUrl: 'https://menu.pickposs.com.tr/',
      copied: false,
      copyTimeout: null,
      windowWidth: window.innerWidth,
      settings: {
        imageEnabled: false,
        logo: ''
      },
      savingSettings: false,
      needUpload: false,
      logoPhotoBinary: null
    }
  },
  computed: {
    menuUrl() {
      if (this.branch && this.branch.uuId) {
        return this.baseUrl + this.branch.uuId;
      }
      return this.baseUrl;
    },
    qrCodeSize() {
      // Return a smaller size for mobile devices
      if (this.windowWidth < 768) {
        return 150;
      } else if (this.windowWidth < 480) {
        return 120;
      }
      return 200;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  created() {
    this.getCurrentBranch();
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    updateLogoImg(input) {
      this.needUpload = true;
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          this.settings.logo = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
        this.logoPhotoBinary = input.target.files[0];
      }
    },

    async uploadLogo() {
      if (!this.logoPhotoBinary) return;

      const formData = new FormData();
      formData.append("image", this.logoPhotoBinary);

      try {
        const response = await uploadImage(formData);
        if (response && response.status === 200) {
          this.settings.logo = "StaticFiles/images/" + response.data;
          this.needUpload = false;
          return true;
        } else {
          this.$vs.notify({
            title: 'Hata',
            text: 'Logo yüklenemedi',
            color: 'danger'
          });
          return false;
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Hata',
          text: 'Logo yükleme sırasında hata oluştu',
          color: 'danger'
        });
        return false;
      }
    },
    async getCurrentBranch() {
      try {
        const response = await currentBranch();
        this.branch = response.data;

        // Settings bilgilerini al
        if (response.data.setting) {
          this.settings = {
            imageEnabled: response.data.setting.imageEnabled || false,
            logo: response.data.setting.logo || ''
          };
        }

        if (!this.branch.uuId) {
          this.$vs.notify({
            title: 'Hata',
            text: 'Şube UUID bilgisi mevcut değil',
            color: 'danger'
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Hata',
          text: 'Şube bilgisi alınamadı',
          color: 'danger'
        });
      }
    },

    copyUrl() {
      const tempInput = document.createElement('input');
      document.body.appendChild(tempInput);
      tempInput.value = this.menuUrl;
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);

      // Show feedback
      this.copied = true;
      clearTimeout(this.copyTimeout);
      this.copyTimeout = setTimeout(() => {
        this.copied = false;
      }, 2000);

      this.$vs.notify({
        title: 'Başarılı',
        text: 'Menü URL kopyalandı',
        color: 'success'
      });
    },

    printQRCode() {
      const printWindow = window.open('', '', 'width=800,height=600');
      const canvas = document.querySelector('.qr-code-container canvas');
      const imgData = canvas.toDataURL('image/png');

      printWindow.document.write(`
        <html>
          <head>
            <title>${this.branch.name || 'Şube'} - QR Menü</title>
            <style>
              body { font-family: Arial, sans-serif; text-align: center; padding: 20px; }
              .qr-container { margin: 20px auto; }
              h1 { margin-bottom: 10px; }
              p { margin-bottom: 20px; }
              img { max-width: 100%; height: auto; }
              @media print {
                img { max-width: 250px; }
              }
            </style>
          </head>
          <body>
            <h1>${this.branch.name || 'Şube'} QR Menü</h1>
            <div class="qr-container">
              <img src="${imgData}" />
            </div>
            <p>Menü URL: ${this.menuUrl}</p>
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.focus();

      // Wait for image loading
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    },

    downloadPDF() {
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const canvas = document.querySelector('.qr-code-container canvas');
      const imgData = canvas.toDataURL('image/png');

      // Calculate center position for A4 page (210 x 297 mm)
      const pageWidth = 210;
      const qrSize = 70; // QR code size in mm
      const xPos = (pageWidth - qrSize) / 2;

      // Add content to PDF
      doc.setFontSize(20);
      doc.text(`${this.branch.name || 'Şube'} QR Menü`, 105, 30, { align: 'center' });

      // Add QR code image
      doc.addImage(imgData, 'PNG', xPos, 50, qrSize, qrSize);

      // Add URL text
      doc.setFontSize(12);
      doc.text('Menü URL:', 105, 140, { align: 'center' });
      doc.text(this.menuUrl, 105, 150, { align: 'center' });

      // Save PDF
      doc.save(`${this.branch.name || 'sube'}-qr-menu.pdf`);

      this.$vs.notify({
        title: 'Başarılı',
        text: 'QR Kod PDF olarak indirildi',
        color: 'success'
      });
    },

        async saveSettings() {
      this.savingSettings = true;
      try {
        // Eğer yeni logo yüklendiyse önce upload işlemini yap
        if (this.needUpload && this.logoPhotoBinary) {
          const uploadSuccess = await this.uploadLogo();
          if (!uploadSuccess) {
            this.savingSettings = false;
            return;
          }
        }

        const branchSetting = {
          imageEnabled: this.settings.imageEnabled,
          logo: this.settings.logo
        };

        await setQrMenuSetting(branchSetting);

        this.$vs.notify({
          title: 'Başarılı',
          text: 'QR Menü ayarları başarıyla kaydedildi',
          color: 'success'
        });
      } catch (error) {
        this.$vs.notify({
          title: 'Hata',
          text: 'Ayarlar kaydedilirken bir hata oluştu',
          color: 'danger'
        });
      } finally {
        this.savingSettings = false;
      }
    }
  }
}
</script>

<style scoped>
.qr-menu-container {
  max-width: 800px;
  margin: 0 auto;
}

.qr-code-container {
  display: inline-block;
  border-radius: 8px;
  max-width: 100%;
}

.qr-code-container >>> canvas {
  max-width: 100%;
  height: auto !important;
}

.menu-url {
  width: 100%;
  max-width: 500px;
}

@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
  }

  .action-buttons .vs-button {
    margin-right: 0;
    margin-bottom: 10px;
    width: 100%;
  }

  .url-copy-container {
    flex-direction: column;
  }

  .url-copy-container .vs-button {
    margin-top: 10px;
    margin-left: 0;
    width: 100%;
  }
}

.logo-preview-container {
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.logo-preview {
  display: block;
  margin: 0 auto;
}
</style>
